import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useRealtimeTable } from "./useRealtime";

export type JobLog = {
  id: string;
  job_id: string;
  event: string;
  message: string | null;
  created_at: string;
};

export function useJobLogs(jobId: string | undefined) {
  useRealtimeTable("agent_job_logs", ["job-logs", jobId ?? ""]);

  return useQuery({
    queryKey: ["job-logs", jobId],
    queryFn: async () => {
      if (!jobId) return [];
      const { data, error } = await supabase
        .from("agent_job_logs")
        .select("*")
        .eq("job_id", jobId)
        .order("created_at", { ascending: true });

      if (error) throw error;
      return data as JobLog[];
    },
    enabled: !!jobId,
    refetchInterval: 10_000,
  });
}
